import { render, staticRenderFns } from "./i-nav.vue?vue&type=template&id=3113f94b&scoped=true"
import script from "./i-nav.vue?vue&type=script&lang=js"
export * from "./i-nav.vue?vue&type=script&lang=js"
import style0 from "./i-nav.vue?vue&type=style&index=0&id=3113f94b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3113f94b",
  null
  
)

export default component.exports